export default {
	teams: {
		teamMember: 'Team member | Team members',
		accountDetails: 'Account Details',
		buildingAssignment: 'Building Assignment',
		permissions: 'Permissions',
		deleteData: 'Delete data',
		createData: 'Create data',
		updateData: 'Update data',
		viewAllReports: 'View all reports',
		accessSettings: 'Access settings',
		hideContactInformation: 'Hide contact information',
		profilePicture: 'Profile picture',
		selectTeamMember: 'Select team member',
		create: 'create',
		assigned_to: 'Assigned to',
		active: 'Active',
		deactivate: 'Deactivate',
		activate: 'Activate',
		inactive: 'Inactive',
		showInactive: 'Show inactive',
		activeManagedByErp:
			'The active state comes from HausPerfekt and is maintained there.',
	},
}
